import { requestApi } from 'api/api'
import { BASE_API_URL } from 'constants/General'
import { EmbeddedAgreementPayloadStatuses } from 'pages/EmbeddedCustomerTerms/helpers/constants'
import {
  EmbeddedCustomerAgreemenstData,
  EmbeddedCustomerAgreementPayload,
} from 'pages/EmbeddedCustomerTerms/helpers/types'

export const EMBEDDED_CUSTOMERS_API = '/platform/v1/customers/agreement/sessions'

export const getEmbeddedCustomerAgreements = (
  reference: string
): Promise<EmbeddedCustomerAgreemenstData> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `${EMBEDDED_CUSTOMERS_API}/${reference}`,
    method: 'GET',
    authenticated: false,
  })
}

export const submitEmbeddedCustomerAgreements = ({
  reference,
}: EmbeddedCustomerAgreementPayload): Promise<void> => {
  return requestApi({
    baseUrl: BASE_API_URL,
    url: `${EMBEDDED_CUSTOMERS_API}/${reference}`,
    method: 'PUT',
    authenticated: false,
    data: { status: EmbeddedAgreementPayloadStatuses.SIGNED },
  })
}
